import { styled, ListItem, lighten } from "@tm/components"

export const FilterListItem = styled(ListItem)(({ theme }) => ({
    "&.suggested": {
        backgroundColor: lighten(theme.palette.highlight.light, 0.4),
    },
}))
